/**
 * @generated SignedSource<<e9ea77fdf8a59f673029fe26a13699d0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type AccountQuery$variables = {};
export type AccountQuery$data = {
  readonly music_viewer: {
    readonly me: {
      readonly id: string;
      readonly email: string | null;
    };
  };
};
export type AccountQuery = {
  variables: AccountQuery$variables;
  response: AccountQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "MusicViewer",
    "kind": "LinkedField",
    "name": "music_viewer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AccountQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "AccountQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "68907ffb39bbb5dbd9e73525374cd8a1",
    "id": null,
    "metadata": {},
    "name": "AccountQuery",
    "operationKind": "query",
    "text": "query AccountQuery {\n  music_viewer {\n    me {\n      id\n      email\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "03bdff5827aa89a3c2f73a7f8987270a";

export default node;
